import React from "react";
import { Loader2 } from "lucide-react";
import SEO from "../components/SEO";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HomeMapExplorer from "../components/HomeMapExplorer";
import { useLocation } from "react-router-dom";
import { useSettings } from "../contexts/SettingsContext";
import { useAppContext } from "../store/AppContext";

export default function MapPage() {
  const location = useLocation();
  const { settings } = useSettings();
  const {
    locations = [],
    loading: mapDataLoading,
    error: mapDataError,
    toggleFavorite,
    isFavorite,
  } = useAppContext();

  const siteName = (settings?.siteName || "").trim() || "Lòng Vòng Đà Lạt";
  const params = new URLSearchParams(location.search || "");
  const initialOnlyFavorites = params.get("fav") === "1";

  return (
    <>
      <SEO
        title={`Bản đồ – ${siteName}`}
        description="Bản đồ tương tác: tìm kiếm, lọc và xem chi tiết các địa điểm tại Đà Lạt."
        url={`${(settings?.siteUrl || "https://longvongdalat.com").replace(/\/$/, "")}/map`}
      />

      <Header />

      <main className="relative w-full">
        <div className="relative h-[calc(100dvh-72px)] min-h-[520px] w-full overflow-hidden bg-[#dfe6d9] md:h-[calc(100dvh-80px)]">
          {mapDataLoading ? (
            <div className="flex h-full flex-col items-center justify-center gap-3">
              <Loader2 className="h-10 w-10 animate-spin text-[#4d5c48]" aria-hidden />
              <span className="text-sm font-medium text-[#4d5c48]/80">Đang tải bản đồ…</span>
            </div>
          ) : mapDataError ? (
            <div className="flex h-full flex-col items-center justify-center gap-3 px-4 text-center">
              <p className="max-w-md text-sm text-red-800">{mapDataError}</p>
            </div>
          ) : (
            <HomeMapExplorer
              locations={locations}
              loading={mapDataLoading}
              error={mapDataError}
              isFavorite={isFavorite}
              toggleFavorite={toggleFavorite}
              introPhase="none"
              preferDensestOnLoad
              initialOnlyFavorites={initialOnlyFavorites}
            />
          )}
        </div>
      </main>

      <Footer />
    </>
  );
}

